import {
  FiBriefcase,
  FiCalendar,
  FiBarChart2,
  FiCreditCard,
  FiDollarSign,
  FiFileText,
  FiHome,
  FiMessageSquare,
  FiPackage,
  FiSettings,
  FiStar,
  FiTag,
  FiUsers,
} from 'react-icons/fi';

// Keep desktop and mobile navigation sourced from the same list so the two
// menus cannot silently drift apart as admin features are added.
const navigationItems = [
  { path: '/', name: 'Dashboard', icon: FiHome },
  { path: '/reports', name: 'Reports', icon: FiBarChart2 },
  { path: '/users', name: 'Users', icon: FiUsers },
  { path: '/cancellations', name: 'Recorded Cancellations', icon: FiCalendar },
  { path: '/jobs', name: 'Jobs', icon: FiBriefcase },
  { path: '/applications', name: 'Applications', icon: FiFileText },
  { path: '/bids', name: 'Bids', icon: FiDollarSign },
  { path: '/subscriptions', name: 'Subscriptions', icon: FiCreditCard },
  { path: '/operations', name: 'Operations & Messages', icon: FiDollarSign },
  { path: '/reviews', name: 'Reviews', icon: FiStar },
  { path: '/support-tickets', name: 'Support Tickets', icon: FiMessageSquare },
  { path: '/promo-codes', name: 'Promo Codes', icon: FiTag },
  { path: '/settings', name: 'Settings', icon: FiSettings },
  { path: '/pages', name: 'Pages', icon: FiPackage },
];

export default navigationItems;
